define('drops/timer/timer',[
    'jquery',
    'lq/drop'
], function ($, Drop) {
    'use strict';

    var defaults = {
        data: {
            intervalOption: 'Hard Coded',
            autoStart: true
        }
    };

    function Timer(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.timer = 1000 * 60;
    };

    Drop.extend(Timer);

    Timer.typeName = 'Timer';

    Timer.prototype.postRender = function () {
        if (this.data.autoStart)
            this.piping.eventing.subscribe('PageLoad', this.startTimer.bind(this));
    };

    Timer.prototype.startTimer = function () {
        var self = this;
        var timerElapsedEvent = self.getEventDataFor('timerElapsed');
        if (timerElapsedEvent.enabled) {
            if (self.data.intervalOption === "Hard Coded") {
                self.timer = 1000 * self.data.interval;
                setTimeout(function () {
                    self.triggerEvent(timerElapsedEvent.raisedEventName);
                }, self.timer);
            }
            else {
                this.piping.datasources.registerDatasourceListener(self.data.dataSourceForInterval, function (data) {
                    self.timer = 1000 * data.Results[0][self.data.dataSourceOutputForInterval];
                    setTimeout(function () {
                        self.triggerEvent(timerElapsedEvent.raisedEventName);
                    }, self.timer);
                });
            }
        }
    };
    
    return Timer;
});
